// Admin card sentence for the last FAILED auto re-login of a Flow source Gmail (2026-10-26).
// The owner-PC monitor writes `reloginStatus/reloginReason/reloginJenis/reloginAt` on the account
// doc; before this the failure lived only in the monitor log and the owner thought the robot never
// tried (flow_02, 13–26 Oct: the vault entry was unreadable on every attempt). Admin UI = English.
// TWIN: functions/flowReloginJenis.js decides hard / peti_besi / transient from the SAME codes —
// a code added there needs its sentence here.
const VAULT = 'Secret Manager (project sesaat-flow)';

export function ayatReloginGagal(reason, jenis, profileId) {
    const kod = String(reason || '').trim();
    const nama = /^\d{1,15}$/.test(String(profileId || '')) ? `gmail-${profileId}` : 'the gmail-<GenLogin id> entry';
    const sebab = {
        SERVER_FORMAT_RAHSIA_ROSAK: `the saved password entry ${nama} cannot be read (not valid JSON). Add a new version in ${VAULT}: {"email":"…","password":"…","totp":"…"} — straight quotes, one line, nothing before or after.`,
        SERVER_RAHSIA_TIADA: `no password is saved for this GenLogin profile. Add ${nama} in ${VAULT}.`,
        RAHSIA_TIADA: `no password is saved for this GenLogin profile. Add ${nama} in ${VAULT}.`,
        SERVER_RAHSIA_TAK_LENGKAP: `${nama} has no email or no password in it.`,
        SERVER_SERVER_TIADA_IZIN_BACA: 'the vault refused to let the robot read the password (permission).',
        SERVER_TIDAK_DIBENARKAN: 'the vault rejected the robot key on this PC.',
        PASSWORD_DITOLAK: `Google rejected the saved password. Update it in ${nama}.`,
        KOD_2FA_DITOLAK: `Google rejected the 2FA code. Check the "totp" key in ${nama}.`,
        PERLU_2FA_TAPI_TIADA_KUNCI: `Google asks for a 2FA code but ${nama} has no "totp" key.`,
        CAPTCHA: 'Google asked for a CAPTCHA. Log in by hand in GenLogin.',
        DITOLAK_GOOGLE: 'Google blocked the sign-in. Log in by hand in GenLogin.',
        CABARAN_LAIN: 'Google asked for another check (phone / device). Log in by hand in GenLogin.',
    }[kod] || (/^KUNCI_ROBOT_TIADA\b/.test(kod) ? 'the robot key file is missing on this PC (.env.robot).' : (kod || 'unknown reason').replace(/[.!?]+$/, '') + '.');
    const lepas = jenis === 'peti_besi' ? ' The robot tries again once an hour until this is fixed.'
        : jenis === 'hard' ? ' The robot will not try again until someone logs in by hand.'
            : jenis === 'transient' ? ' The robot will try again.' : '';
    return sebab + lepas;
}
